import {MY_ASSET_LIST_TYPE_BY_PROP, MY_ASSET_TYPE_LIST} from "components/Layout/constants";
import styles from "./index.module.scss";
import {useIntl} from "react-intl";
import {useSearchParams} from "react-router-dom";
import Button from "components/Common/Button";
import Favorites from "components/FavoritesTab/Favorites";
import AssetTab from "components/MyTab/AssetTab";

export const TypeAsset = ({currentType, memoizedSetCurrentType}) => {
  const intl = useIntl();
  const [searchParams] = useSearchParams();
  const listType = MY_ASSET_LIST_TYPE_BY_PROP[currentType];
  return (
    <>
      <div className={styles.types}>
        {MY_ASSET_TYPE_LIST.map(assetType => {
          const {type, title} = assetType;
          return (
            <Button
              key={type}
              type={currentType === type ? "selected" : "default"}
              htmlType="button"
              onClick={() => memoizedSetCurrentType(type)}
            >
              {intl.formatMessage({id: title})}
            </Button>
          );
        })}
      </div>
      <div className={styles.contents}>
        {searchParams.get("tab") === "Favorites" ? (
          <Favorites listType={listType} currentType={currentType} />
        ) : (
          <AssetTab listType={listType} currentType={currentType} setCurrentType={memoizedSetCurrentType} />
        )}
      </div>
    </>
  );
};
